import { formatLocaleDate } from "@/lib/dates";
import { useLocale } from "@/i18n";
import { Notice } from "@/components/Notice";
import { CalendarIcon } from "@/components/ui/Icons";

export interface NoAvailabilityNoticeProps {
  arrival: string;
  departure: string;
  nights: number;
  wantsElectricity?: boolean;
  onTryWithoutElectricity?: () => void;
}

export function NoAvailabilityNotice({
  arrival,
  departure,
  nights,
  wantsElectricity = false,
  onTryWithoutElectricity,
}: NoAvailabilityNoticeProps) {
  const { messages: m, locale } = useLocale();
  const nightLabel = nights === 1 ? m.common.night : m.common.nights;

  return (
    <Notice variant="warning" title={m.availability.soldOutTitle} icon={<CalendarIcon />}>
      <p>
        {m.availability.soldOutBody(
          formatLocaleDate(arrival, locale),
          formatLocaleDate(departure, locale),
          nights,
          nightLabel,
        )}
      </p>
      <p className="text-amber-900/80">{m.availability.soldOutHint}</p>
      {wantsElectricity && onTryWithoutElectricity ? (
        <button
          type="button"
          onClick={onTryWithoutElectricity}
          className="mt-1 inline-flex items-center rounded-lg border border-amber-300 bg-white px-3 py-1.5 text-xs font-semibold text-amber-900 transition hover:bg-amber-100"
        >
          {m.availability.tryWithoutElectricity}
        </button>
      ) : null}
    </Notice>
  );
}
